import React from 'react';
import {Dropped, Dropzone} from './DragAndDrop.style';
import {useDropzone} from 'react-dropzone';
import {t} from 'i18next';
import {formatSize} from '../../utils';
import {generateIdentifier} from '../../utils/IdentityUtils';

export interface DragAndDropProps {
    readonly browseFile: File | null;
    readonly acceptImagesOnly: boolean;
    onChange: (selectedFile: File | null) => void;
}

/**
 * @name DragAndDrop
 * @description
 * A component drag to allow data to be referenced via drag and drop
 */
export const DragAndDrop: React.VFC<DragAndDropProps> = (props) => {
    const handleFile = (files: File[]) => {
        files.map(file => props.onChange(file));
    };

    const {fileRejections, getRootProps} = useDropzone({
        maxFiles: 1,
        onDrop: handleFile,
        accept: (props.acceptImagesOnly ? {'image/*': []} : undefined),
        noClick: true,
        onDropRejected: () => props.onChange(null)
    });

    return (
        <Dropzone id={generateIdentifier()} {...getRootProps({className: 'dropzone'})}>
            {((!props.browseFile) && (fileRejections.length === 0)) ? (
                t('DRAG_AND_DROP_COMPONENT_DROP_AREA_INFO_TEXT')
            ) : (
                <Dropped id={generateIdentifier()}>
                    {((!props.browseFile) && (fileRejections.length === 1))
                        ? t('DRAG_AND_DROP_COMPONENT_ERROR_MULTIPLE_FILES_INFO_TEXT')
                        : ((!props.browseFile) && (fileRejections.length > 1))
                            ? t('ERROR_MULTIPLE_FILES_INFO_TEXT')
                            : props.browseFile &&
                            t('DRAG_AND_DROP_COMPONENT_DRAGGED_FILE_INFO_TEXT', {
                                name: props.browseFile.name,
                                size: formatSize(props.browseFile.size)
                            })
                    }
                </Dropped>
            )}
        </Dropzone>
    );
};
